import { Box, Button, Card, CardActions, CardContent, CardHeader, Switch, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const TabPanel = (props: any) => {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

type CookiesConsentStepTwoProps = {
  onChange: (event: any) => void;
  cookiePreferences: CookiePreferences;
  onAcceptCookies: () => void;
  onRejectCookies: () => void;
  onSavePreferences: () => void;
};
const CookiesConsentStepTwo = ({
  onChange,
  cookiePreferences,
  onAcceptCookies,
  onRejectCookies,
  onSavePreferences,
}: CookiesConsentStepTwoProps) => {
  const { t } = useTranslation();

  const [value, setValue] = useState(0);

  const handleChange = (_: any, newValue: any) => {
    setValue(newValue);
  };

  return (
    <Card sx={{ maxWidth: 600 }} className="cookies-consent">
      <CardHeader
        titleTypographyProps={{
          fontSize: 12,
        }}
        title={t("legal-section.cookies-consent.title")}
      />
      <CardContent>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            height: 224,
          }}
        >
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            sx={{ borderRight: 1, borderColor: "divider" }}
          >
            <Tab label={t("legal-section.cookies-consent.essential-title")} />
            <Tab label={t("legal-section.cookies-consent.technical-title")} />
            <Tab label={t("legal-section.cookies-consent.analytical-title")} />
            <Tab label={t("legal-section.cookies-consent.personalisation-title")} />
            <Tab label={t("legal-section.cookies-consent.advertising-title")} />
          </Tabs>
          <TabPanel value={value} index={0}>
            <Box sx={{ maxWidth: 400 }}>{t("legal-section.cookies-consent.essential-content")}</Box>
            <Switch disabled defaultChecked />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Box sx={{ maxWidth: 400 }}>{t("legal-section.cookies-consent.technical-content")}</Box>
            <Switch disabled defaultChecked />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Box sx={{ maxWidth: 400 }}>{t("legal-section.cookies-consent.analytical-content")}</Box>
            <Switch name="analytical" checked={cookiePreferences.analytical} onChange={onChange} />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <Box sx={{ maxWidth: 400 }}>{t("legal-section.cookies-consent.personalisation-content")}</Box>
            <Switch name="personalisation" checked={cookiePreferences.personalisation} onChange={onChange} />
          </TabPanel>
          <TabPanel value={value} index={4}>
            <Box sx={{ maxWidth: 400 }}>{t("legal-section.cookies-consent.advertising-content")}</Box>
            <Switch name="advertising" checked={cookiePreferences.advertising} onChange={onChange} />
          </TabPanel>
        </Box>
      </CardContent>
      <CardActions style={{ justifyContent: "center" }}>
        <Button variant="contained" size="small" onClick={onAcceptCookies}>
          {t("legal-section.cookies-consent.accept")}
        </Button>
        <Button variant="contained" size="small" onClick={onRejectCookies}>
          {t("legal-section.cookies-consent.reject")}
        </Button>
        <Button variant="contained" size="small" onClick={onSavePreferences}>
          {t("legal-section.cookies-consent.save-preferences")}
        </Button>
      </CardActions>
    </Card>
  );
};

export default CookiesConsentStepTwo;
